import { Outlet } from 'react-router-dom';

import { useDeviceName } from '@/api/devices';
import { useSpotterContext } from '@/context/SpotterContext';
import { SpotterNotFound } from '@/pages/SpotterNotFound';

export const SpotterLayout = () => {
    const { errorPage } = useSpotterErrorPage();

    if (errorPage) {
        return errorPage;
    }

    return <Outlet />;
};

export const useSpotterErrorPage = () => {
    const { spotterId } = useSpotterContext();
    const { isLoading, error } = useDeviceName();

    const spotterNotFound = !isLoading && error?.message.match(/not found/i);

    if (spotterNotFound) {
        return { errorPage: <SpotterNotFound spotterId={spotterId} /> };
    }

    return { errorPage: null };
};
